import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Plus, X, RefreshCw, Loader2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const STATUS_TEXT = {
  processando: "Classificando…",
  automatica: "Automática",
  manual: "Corrigida pela equipe",
  aguardando: "Aguardando classificação",
  falhou: "Classificação falhou",
};

export const Classification = ({ msg, onPatch, onReclassify }) => {
  const { categories } = useOutletContext();
  const [busy, setBusy] = useState(false);
  const ids = msg.category_ids || [];
  const byId = Object.fromEntries(categories.map((c) => [c.id, c]));
  const waiting = categories.find((c) => c.slug === "aguardando");
  const set = (next) => onPatch(msg.id, { category_ids: next });
  const remove = (id) => set(ids.filter((x) => x !== id));
  const add = (id) => set([...ids.filter((x) => x !== waiting?.id), id]);
  const cls = msg.classification || {};
  const redo = async () => {
    setBusy(true);
    await onReclassify(msg.id);
    setBusy(false);
  };
  return (
    <div data-testid={`msg-classification-${msg.id}`} className="mb-1.5 space-y-1">
      <div className="flex flex-wrap items-center gap-1">
        {ids.map((id) => (
          <span key={id} data-testid={`msg-cat-chip-${msg.id}-${byId[id]?.slug || id}`}
            className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs font-semibold ${byId[id]?.slug === "aguardando" ? "bg-zap-goldsoft text-[#7A5A14]" : "bg-zap-deep/10 text-zap-deep"}`}>
            {byId[id]?.name || "Categoria removida"}
            {byId[id]?.slug !== "aguardando" && (
              <button data-testid={`msg-cat-remove-${msg.id}-${byId[id]?.slug || id}`} onClick={() => remove(id)} aria-label="Remover categoria" className="rounded hover:bg-black/10"><X className="h-3 w-3" /></button>
            )}
          </span>
        ))}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button data-testid={`msg-cat-add-${msg.id}`} aria-label="Adicionar categoria" className="inline-flex h-5 w-5 items-center justify-center rounded border border-zap-line bg-white/70 hover:bg-white"><Plus className="h-3 w-3" /></button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="max-h-72 overflow-y-auto">
            {categories.filter((c) => c.slug !== "aguardando" && !ids.includes(c.id)).map((c) => (
              <DropdownMenuItem key={c.id} data-testid={`msg-cat-option-${msg.id}-${c.slug || c.id}`} onSelect={() => add(c.id)}>{c.name}</DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <p className="flex min-w-0 items-center gap-1.5 text-xs text-zap-ink/70">
        <span data-testid={`msg-cls-status-${msg.id}`}>{STATUS_TEXT[cls.status] || "Sem classificação"}</span>
        {cls.methods?.length > 0 && cls.status !== "manual" && <span className="shrink-0 whitespace-nowrap">· {cls.methods.join(", ")}</span>}
        {cls.notes?.length > 0 && <span className="min-w-0 truncate">· {cls.notes.join("; ")}</span>}
        <button data-testid={`msg-reclassify-${msg.id}`} onClick={redo} disabled={busy} title="Classificar novamente" className="ml-1 rounded p-0.5 hover:bg-black/10">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <RefreshCw className="h-3 w-3" />}
        </button>
      </p>
      {msg.transcript && (
        <p data-testid={`msg-transcript-${msg.id}`} className="rounded bg-black/5 px-2 py-1 text-[13px] italic leading-snug">Transcrição: “{msg.transcript}”</p>
      )}
    </div>
  );
};
